import axios from "axios";
import { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";


import Swal from "sweetalert2";
import GreenButton from "../../../../ui/GreenButton";



const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const FormContainer = styled.form`
  width: 50%;
  background-color: #fff;
  display: flex; 
  align-items: flex-end;
  justify-content: center;
  gap: 5px;
  padding: 10px;

`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  width: 805px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 7px;
  height: 37px;

  
`;

const Label = styled.label`
  color: #4f4f4f;
  font-weight: 600;
  font-size: 17px;

 
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; 
  padding-left: 1px;

  
`;


const LinhaHorizontal = styled.hr`
  border: none;
  height: 1px;
  background-color: #ccc;
  margin: 16px 0;
  
`;

const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  

  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;


export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;


const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;

  @media (max-width: 640px) {
    align-items: center; 
    text-align: center;
  }
  @media (max-width: 420px) {
    align-items: center; 
    text-align: center;
  }
`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  
`;

export const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
 
`;

export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;

  
`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
  
`;

export const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;






const Form = ({ urlApi, tipoChamado, setAtualizaTipos }) => {

  //-------------------------------------------------------------------------------------------------//

  const ref = useRef();

  //-------------------------------------------------------------------------------------------------//

  const token = localStorage.getItem('token');

  //----------------------------------------ONEDIT RESPONSAVEL POR EDITAR O MODULO---------------------------------------------------------//

  const [onEdit, setOnEdit] = useState(null);
  useEffect(() => {
    if (onEdit) {
      const user = ref.current;
      user.desc_tipochamado.value = onEdit.DESC_TIPOCHAMADO;

    };
  }, [onEdit]);



  //onEdit para editar os modulo
  const handleEdit = (item) => {
    setOnEdit(item);
  };

  //----------------------------------------FUNÇÂO QUE SALVA POST/PUT---------------------------------------------------------//

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = ref.current;
    const desc_tipochamadoValue = user.desc_tipochamado.value.trim();


    if (!desc_tipochamadoValue) {
      return toast.warn("Preencha todos os campos!");
    }


    const tipoChamadoData = {
      desc_tipochamado: desc_tipochamadoValue,

    };

    const url = onEdit
      ? `${urlApi}central-ti/editar-tipo-chamado/${onEdit.COD_TIPOCHAMADO}`
      : `${urlApi}central-ti/adicionar-tipo-chamado`;

    const method = onEdit ? "put" : "post";

    try {
      const response = await axios({
        method,
        url,
        data: tipoChamadoData,
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data);
      setAtualizaTipos(true);


      user.desc_tipochamado.value = "";
      setOnEdit(null);
    } catch (error) {
      let errorMessage = "Erro desconhecido";
      if (error.response) {
        errorMessage = error.response.data.error || errorMessage;

        toast.error("Erro ao adicionar: " + errorMessage);
      } else {
        console.error("Erro na solicitação:", error.message);
        toast.error("Erro na solicitação: " + error.message);
      }

    }
  };


  //----------------------------------------FUNÇÂO QUE DELETA O MODULO---------------------------------------------------------//

  //PopUp de confirmação para deletar
  const showPopUp = (detalhes) => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de deletar esse tipo chamado: ${detalhes}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };



  // Deleta os usuários
  const handleDelete = async (item) => {
    const detalhes = `${item.DESC_TIPOCHAMADO}`;
    const userConfirmed = await showPopUp(detalhes);

    if (!userConfirmed) return;

    try {
      const response = await axios.delete(`${urlApi}central-ti/deletar-tipo-chamado/${item.COD_TIPOCHAMADO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(response.data.message || "Tipo deletado com sucesso.");
      setAtualizaTipos(true);
      setOnEdit(null);

    } catch (error) {
      console.error('Erro ao deletar o módulo:', error);

      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        'Erro desconhecido ao deletar.';

      toast.error("Erro: " + errorMessage);
    }
  };






  //-------------------------------------------------------------------------------------------------//

  return (
    <Div>
      <LinhaHorizontal />
      <FormContainer ref={ref} onSubmit={handleSubmit}>
        <InputArea>
          <Label>Crie um novo tipo de chamado:</Label>
          <Input name="desc_tipochamado" type="text" placeholder="Digite aqui..." />
        </InputArea>


        <ButtonContainer>
          <GreenButton title="Salvar" type="submit">
            Salvar
          </GreenButton>
        </ButtonContainer>
      </FormContainer>

      <LinhaHorizontal />



      {tipoChamado === 0 ? (
        <Tr>
          <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
            Nenhum tipo encontrado.
          </Td>
        </Tr>
      ) : (
        <>

          <TableWrapper>
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Tipo</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {tipoChamado.map((item, i) => (
                  <tr key={i}>
                    <td>{item.COD_TIPOCHAMADO}</td>
                    <td>{item.DESC_TIPOCHAMADO}</td>


                    <td>
                      <ActionButton onClick={() => handleEdit(item)}>
                        Editar
                      </ActionButton>
                    </td>
                    <td>
                      <ActionButton onClick={() => handleDelete(item)}>
                        Deletar
                      </ActionButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableWrapper>
        </>
      )}
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </Div>

  );
};

export default Form;


